import { colors } from 'theme'

export const defaultThemeStyles = {
    textMain: colors.grey,
    background: colors.grey,
    border: colors.grey,
}
